/* eslint-disable */
import { http } from '@/helpers/http';

const defaultDeveloper = {
  id: 'new',
  is_active: false,
  name: '',
  alias: '',
  passed_objects_percent: '',
  passed_objects_count: '',
  year_foundation: '',
  in_work_objects_count: '',
  no_developer_logo: false,
  completion_to: '',
  logo: null,
  logo_white: null,
  picture_about: null,
  preview_text: '',
  detail_text: '',

  // Вкладка SEO
  seo_title: '',
  seo_description: '',
  seo_keywords: '',
};

export default {
  namespaced: true,
  state() {
    return {
      list: [], // Список застройщиков
      search: '', // Поисковое слово в списке
      current: defaultDeveloper,
    };
  },

  mutations: {
    /* Записать новый список */
    setList (state, data) {
      state.list = data.slice();
    },

    /* Установить поисковое слово */
    setSearch (state, data) {
      state.search = data;
    },

    /* Установить свойство текущего объекта */
    setValue (state, payload) {
      state.current = {
        ...state.current,
        ...payload
      }
    },

    /* Очистить текущее значение */
    clearCurrent (state) {
      state.current = {
        ...state.current,
        ...defaultDeveloper
      }
    },

    /* Удалить из списка */
    removeFormList (state) {
      const index = state.list.findIndex(({id}) => id === state.current.id);
      state.list.splice(index, 1);
    },

    /* Установить текущий объект по идентификатору */
    setCurrent (state, _id) {
      const promo = state.list.find(({ id }) => id === _id )
      state.current = {
        ...state.current,
        ...promo
      }
    },

    /* Заменить по идентификатору */
    replaceById (state, current) {
      const index = state.list.findIndex(({ id }) => id === current.id);
      state.list.splice(index, 1, current);
    },

    /* Добавить в список */
    addList (state, current) {
      state.list.push({...current, id: state.list.length + 1 });
    }
  },

  getters: {
    getItems: state => state.list.map(item => {
      return {
        id: item.id,
        name: item.title
      }
    }),

    // getList: state => state.list.filter(({ title }) => title.indexOf(state.search) >= 0),

    getList: state => state.list
    .filter(({ name }) => name.toLowerCase().indexOf(state.search.toLowerCase()) >= 0)
    .map(({ id, alias, is_active, name, updated_at_formatted }) => {
      return {
        id,
        alias,
        is_active: is_active ? 'Да' : 'Нет',
        name,
        updated_at: updated_at_formatted
      };
    }),

    getById: state => _id => state.list.find(({ id }) => id === _id ),

    getCurrent: state => state.current,

    getFormatList: (state, getters) => {
      return getters.getList.map(obj => ({
        ...obj,
        is_active: obj.is_active ? 'Да' : 'Нет'
      }))
    }
  },

  actions: {
    async getList({ commit }) {
      try {
        const { data } = await http.post('/admin/developers');
        commit('setList', data);
        console.log('data', data)
      } catch (e) {
        throw e;
      }
    },

    async remove({ commit }, id) {
      await http.post('/admin/developers/remove', { id });
      commit('clearCurrent');
    },

    async getById({ commit }, id) {
      if (id === null || id === 'new') {
        commit('clearCurrent');
        return;
      }

      const { data } = await http.post('/admin/developers/edit', { id });
      commit('setValue', data);
    },


    async save({ state }) {
      // Это новый элемент или редактирование?
      const isNew = state.current.id === 'new' || state.current.id === null;

      if (!isNew) {
        const { data: id } = await http.post('/admin/developers/store', {
          id: state.current.id,
          is_active: state.current.is_active,
          name: state.current.name,
          alias: state.current.alias,
          passed_objects_percent: state.current.passed_objects_percent,
          passed_objects_count: state.current.passed_objects_count,
          year_foundation: state.current.year_foundation,
          in_work_objects_count: state.current.in_work_objects_count,
          no_developer_logo: state.current.no_developer_logo,
          completion_to: state.current.completion_to,
          logo: state.current.logo,
          logo_white: state.current.logo_white,
          picture_about: state.current.picture_about,
          preview_text: state.current.preview_text,
          detail_text: state.current.detail_text,
          seo_description: state.current.seo_description,
          seo_keywords: state.current.seo_keywords,
          seo_title: state.current.seo_title
        });
        console.log('id', id)
        return id;
      } else {
        const { data: id } = await http.post('/admin/developers/store', {
          is_active: state.current.is_active,
          name: state.current.name,
          alias: state.current.alias,
          passed_objects_percent: state.current.passed_objects_percent,
          passed_objects_count: state.current.passed_objects_count,
          year_foundation: state.current.year_foundation,
          in_work_objects_count: state.current.in_work_objects_count,
          no_developer_logo: state.current.no_developer_logo,
          completion_to: state.current.completion_to,
          logo: state.current.logo,
          logo_white: state.current.logo_white,
          picture_about: state.current.picture_about,
          preview_text: state.current.preview_text,
          detail_text: state.current.detail_text,
          seo_description: state.current.seo_description,
          seo_keywords: state.current.seo_keywords,
          seo_title: state.current.seo_title
        });
        console.log('id', id)
        return id;
      }
    }
  },
};
